if (!customElements.get('vf-sticky-buy-bar')) {
  customElements.define(
    'vf-sticky-buy-bar',
    class VfStickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.mediaWrapper = document.querySelector(this.dataset.mediaSelector);

        if (!this.mediaWrapper || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mediaWrapper);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
